/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var formDefaultProps = {
  colon: false,
  labelAlign: "right",
  labelWidth: "100px",
  layout: "vertical",
  preventSubmitDefault: true,
  resetType: "empty",
  showErrorMessage: true,
  submitWithWarningMessage: false
};
var formItemDefaultProps = {
  shouldUpdate: false,
  successBorder: false
};

export { formDefaultProps, formItemDefaultProps };
//# sourceMappingURL=defaultProps.js.map
